<header-title [model]="headerTitle"></header-title>

<section class="panel">
    <div class="row mb-3">
        <div class="col col-md-6">
            <button class="btn btn-primary" type="button" [routerLink]="['/module/add']">Add New Module</button>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-3 text-right">
                    <label class=" control-label">Filter Modules:</label>
                </div>
                <div class="col-md-9">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let module of moduleList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{module.name}}</td>
                        <td class="actions text-center">
                            <a [routerLink]="['/module', module.id]" class="mb-1 mt-1 mr-2 btn-link"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
